module.exports = __webpack_public_path__ + "static/media/information.cab74278.svg";